import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _formSubmission = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _updateOptions = { currentSubmission: '_formSubmission' };
var _validateSubmissionRequest = {
    updateOptions: '_updateOptions',
    submission: '_formSubmission',
};
var _validateSubmissionResponse = {};
function resolveWixFormsV4FormSubmissionSpiExtensionServiceUrl(opts) {
    var domainToMappings = {};
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * > **Note:** The Form Submission service plugin only works with the Wix Forms app. Call [GetAppInstance](https://dev.wix.com/docs/rest/api-reference/app-management/apps/app-instance/get-app-instance) to confirm that the app named `wix_forms` is installed on the site.
 * <br>
 * Validates a submission. <br>
 * Validates a site visitor's form submission and returns any validation violations. <br>
 * Site visitors can see the validation violations on their forms. For example, invalid fields are highlighted in red.
 */
export function validateSubmission(payload) {
    var _a = serializer(_validateSubmissionRequest, { _formSubmission: _formSubmission, _updateOptions: _updateOptions }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validateSubmissionResponse, {}).fromJSON;
    function __validateSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.interfaces.forms.v4.submission_extension',
            method: 'POST',
            methodFqn: 'wix.forms.v4.FormSubmissionSpiExtensionService.ValidateSubmission',
            url: resolveWixFormsV4FormSubmissionSpiExtensionServiceUrl({
                protoPath: '/v4/submissions/validate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateSubmission.fromReq = fromReq;
    __validateSubmission.__isAmbassador = true;
    return __validateSubmission;
}
//# sourceMappingURL=http.impl.js.map